import React from "react";

const Spinner: React.FC = () => {
  return (
    <div className="animate-spin h-10 w-10 border-8 border-jhk-blue rounded-full border-t-transparent"></div>
  );
};

export default Spinner;
